import { Principal } from "../types/Principal";
import api from "./api";

export const getPrincipals = async () => {
  try {
    const response = await api.get("/principals");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch principals", error);
    throw error;
  }
};

export const getPrincipal = async (id: string) => {
  try {
    const response = await api.get(`/principals/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch principal", error);
    throw error;
  }
};

export const createPrincipal = async (principalData: Principal) => {
  try {
    const response = await api.post("principals", principalData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving principal:", error);

    throw error;
  }
};

export const updatePrincipal = async (
  principalId: string,
  updatedData: Principal
) => {
  try {
    const response = await api.put(`principals/${principalId}`, updatedData);
    return response.data;
  } catch (error) {
    console.error("Error updating principal:", error);
    throw error;
  }
};

export const deletePrincipal = async (principalId: string, email: string) => {
  try {
    const response = await api.delete(
      `principals/${principalId}?email=${email}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting principal:", error);
    throw error;
  }
};
